<template>
  <div class="d-flex align-items-center justify-content-center">
    <input
      v-for="(otp, index) in otpForm"
      :key="index"
      type="text"
      maxlength="1"
      v-model="otp.value"
      ref="value"
      @keypress="onlyNumbers"
      @keydown="onKeydown($event, index)"
      @input="onInput($event, index)"
      @paste="onPaste"
      :data-testid="`${testId}${index + 1}`"
    />
    <div class="form-error">
      <small v-if="otpError" :data-testid="`otpError${index + 1}`">{{
        otpError
      }}</small>
    </div>
  </div>
</template>

<script>
import { ref, watch, nextTick, onMounted } from "vue";
import { onlyNumbers } from "@/lib/utils";

export default {
  name: "OtpInput",
  props: {
    modalOtp: {
      type: Boolean,
      default: false
    },
    testId: {
      type: String,
      default: "input"
    },
    length: {
      type: Number,
      default: 6
    }
  },
  setup(props) {
    const otpForm = ref(
      Array.from({ length: props.length }, () => ({ value: "" }))
    );
    const otpError = ref("");
    const value = ref();
    const modalOtpProp = ref(props.modalOtp);

    watch(modalOtpProp, value => {
      if (value) {
        otpForm.value = Array.from({ length: props.length }, () => ({
          value: ""
        }));
        nextTick(() => {
          let input = value.value[0];
          input.focus();
        });
      }
    });

    const focusInput = index => {
      if (index >= 0) {
        let input = value.value[index];
        input.focus();
        input.select();
      }
    };

    const onInput = ($event, index) => {
      if (otpForm.value[index].value && otpForm.value[index + 1]) {
        $event.preventDefault();
        focusInput(index + 1);
      }
    };

    const onDelete = ($event, index) => {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode == 8 || keyCode == 46) {
        $event.preventDefault();
        otpForm.value[index].value = "";
        focusInput(index - 1);
      }
    };

    const onLeft = ($event, index) => {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode == 37) {
        $event.preventDefault();
        focusInput(index - 1);
      }
    };

    const onRight = ($event, index) => {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode == 39 && otpForm.value[index + 1]) {
        $event.preventDefault();
        focusInput(index + 1);
      }
    };

    const onKeydown = ($event, index) => {
      onDelete($event, index);
      onLeft($event, index);
      onRight($event, index);
    };

    const onPaste = $event => {
      let paste = $event.clipboardData.getData("text");
      paste = paste.replace(/[^\d]/g, "");
      $event.preventDefault();

      if (paste.length > otpForm.value?.length) {
        paste = paste.substring(0, otpForm.value?.length);
      }
      paste = paste.split("");

      paste.forEach((value, index) => {
        otpForm.value[index].value = value;
      });
      focusInput(paste.length - 1);
    };

    onMounted(() => {
      nextTick(() => {
        let input = value.value[0];
        input.focus();
        input.select();
      });
    });

    return {
      otpForm,
      otpError,
      onlyNumbers,
      focusInput,
      value,
      onInput,
      onKeydown,
      onPaste
    };
  }
};
</script>

<style scoped>
input {
  background: #ffffff;
  color: #000000;
  font-size: var(--font-lg);
  font-weight: 700;
  text-align: center;
  width: 2.25rem;
  height: 2.25rem;
  margin: 0 0.25rem;
  padding: 0 0.5rem;
  border: 1px solid var(--ch-blue-100);
  border-radius: 6px;
}

input:focus {
  outline: none;
}

@media screen and (min-width: 992px) {
  input {
    font-size: var(--font-xl);
    width: 3rem;
    height: 3rem;
    margin: 0 0.5rem;
  }
}
</style>
